export var NotificationType;
(function (NotificationType) {
    NotificationType["Fail"] = "Fail";
    NotificationType["Success"] = "Success";
    NotificationType["Info"] = "Info";
})(NotificationType || (NotificationType = {}));
